module.exports = __webpack_public_path__ + "img/carrusel1.32638d5a.png";